import React from 'react'
import { Heading } from '@myxplor/ui'

const NoReports = () => <Heading small>No Reports</Heading>


export default NoReports


// WEBPACK FOOTER //
// ./src/reports/views/empty.jsx